document.addEventListener('DOMContentLoaded', function () {
  const elements = document.querySelectorAll('.header-cart-badge');

  // Function to fetch cart data and update elements
  function updateCartBadge() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const cartCount = cart.item_count || 0; // Get cart count
        //console.log(`Fetched cart count: ${cartCount}`);

        elements.forEach((element) => {
          if (cartCount > 0) {
            // Update the badge when cart count is greater than 0
            element.style.display = 'flex'; // Show the badge
            element.style.backgroundColor = '#000000'; // Set background color to black
            element.textContent = cartCount; // Update the count
          } else {
            // Hide the badge when cart count is 0
            element.style.display = 'none';
          }

          /*console.log(
            `Updated badge: Display = ${cartCount > 0 ? 'flex' : 'none'}, Cart Count = ${cartCount}`
          );*/
        });
      })
      .catch((error) => console.error('Error fetching cart data:', error));
  }

  // Initial update on page load
  updateCartBadge();

  // Periodic updates as a fallback
  setInterval(() => {
    //console.log('Periodic cart badge update triggered.');
    updateCartBadge();
  }, 1000); // Update every second
});
